export class QuestionLabel {
  content: string;
  createAccountId: number;
  createTime: number;
  id: number;
  lastModified: number;
  resId: string;
}
